import React from 'react';

export default function useAdminLayoutInit({location}) {
  React.useEffect(() => {
    // trigger only once
  }, []);

  React.useEffect(() => {
    // trigger when location change
  }, [location]);

  return {
    extraElement: null,
  };
}
